import React, { useState, useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faXmark, faCircleCheck, faBolt, faPaperclip, faCircle, faPlus, faEllipsis, faChevronLeft, faChevronRight, faLink, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import JqxTreeGrid from 'jqwidgets-framework/jqwidgets-react-tsx/jqxtreegrid';
import 'jqwidgets-scripts/jqwidgets/jqxtreegrid';
import Trash from "../../../../assets/images/delete.svg";
import Activ from "../../../../assets/images/active.svg";
import Export from "../../../../assets/images/export.svg";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../../assets/images/google-docs.png';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import ActivityComments from '../../../../Components/common/ActivityComments.js';
import DownloadGrid from '../common/DownloadGrid';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { BOOKINGTRUCKDETAILS, BOOKINGTRUCKGRID, BOOKINGTRUCKMOVE, CALENDER } from '../../../../Utils/conts.js';
import ImageUpload from '../../../../Components/common/ImageUpload.js';

import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
import ApexCharts from 'react-apexcharts';


// import jsPDF from 'jspdf';


export const ImportGrid = forwardRef(({ updateGridData, onEdit }, ref) => {
  // console.log("🚀 ~ ExportActive ~ updateGridData:", updateGridData)
  // const myGridRef = useRef(null);
  // let gridElement = null;

  const [downloadOpen, setDownloadOpen] = useState(false);
  const [showSecondDiv, setShowSecondDiv] = useState(false);
  const toggleSecondDiv = () => {
    setShowSecondDiv(!showSecondDiv);
  };

  // +++++++++++++++++++ div +++++++++++++++++++++++++

  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
  };
  const imageUploadRef = useRef(null);
  const browseClick = () => {
      if (imageUploadRef.current) {
          imageUploadRef.current.handleBrowseFiles();
      }
  };
  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };


  // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload 

  const [html, setHtml] = useState('');

  function onChange(e) {
    setHtml(e.target.value);
  }

  // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,

  };

  // +++++++++++++++++++++++++++++++++++ Silk Slider


  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };

  // ++++++++++++++++++++++++++++++++++++ Zoom Image
  const isMounted = useRef(false);
  const isMountedCal = useRef(false);
  const [gridSelect, setGridSelect] = useState([]);
  const [dateData, setDateData] = useState();

  const gridRef = useRef(null);
  // const treeGridRef = useRef(null);
  const [gridData, setGridData] = useState({
    Active: [],
    Trash: [],
    // Trash: []

  });
  // ++++++++++++++ Status Overview.

  const [statusSeries, setStatusSeries] = useState([
    {
      name: 'Units Sold',
      data: [], // [36, 20, 16, 8,]
    },
  ]);

  const maxValue = Math.max(...statusSeries[0].data) + 10;

  const [statusOptions, setStatusOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // This will hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        distributed: true,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      formatter: (val) => {
        return val;
      },
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [
        ['Scheduled'],
        ['To be', 'Planned'],
        ['Planning in', 'Progress'],
        ['Planning', 'Finalized'],
      ],
    },
    yaxis: {
      title: {
        text: ' '
      },
      tickAmount: 5,
      max: maxValue,
      labels: {
        formatter: function (val) {
          return Math.floor(val); // Ensure the y-axis ticks are integers
        }
      }
    },
    fill: {
      opacity: 1,
      colors: [
        "rgba(175, 175, 175, 1)",
        "rgba(255, 85, 34, 1)",
        "rgba(255, 182, 63, 1)",
        'rgba(32, 167, 73, 1)',
      ]
    },
    legend: {
      show: false
    },
    colors: ['#d6d6d6', '#ff5522', '#ffb63f', '#20a749'], // Different colors for each bar group
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " units";
        }
      }
    }
  });



  // ++++++++++++++ Status Overview
  const fetchData = async (tab) => {
    try {
      // const dateP = dateData ? `date: ${dateData}` : ''
      const res = await withRFSToken.post(BOOKINGTRUCKGRID, { tab_name: (tab == 'Active' ? 'IA' : (tab == 'Trash' ? 'IT' : '')), date: dateData ? dateData : '' })
        .then(function (res) {
          const innerData = res.data.Rows;
          const innerDataCal = res.data.chart_data;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
          const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
          setGridData({ Active: innerData, Trash: innerData || [] });
          // Chart
          // setStatusOptions(prevOptions => ({
          //   ...prevOptions,
          //   xaxis: {
          //     ...prevOptions.xaxis,
          //     categories: statusLabel
          //   }
          // }));
          const colors = [
            "rgba(255, 181, 95, 1)",
            "rgba(203, 140, 255, 1)",
            "rgba(99, 169, 255, 1)",
            'rgba(84, 202, 82, 1)',
            'rgba(255, 107, 107, 1)',
          ];

          const condsData = statusData.map((value, index) => ({
            x: statusLabel[index],
            y: value,
            // fillColor: colors[index % colors.length]
          }));
          setStatusSeries([{
            name: "ULD's",
            data: condsData
          }]);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    fetchData(activeTab);
    // fetchCallanderData();
    isMounted.current = true;
  }, []);

  const [activeTab, setActiveTab] = useState('Active');

  const gridRefs = {
    Active: useRef(null),
    Trash: useRef(null),
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    fetchData(tab)

    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
  };

  const [selectedRowData, setSelectedRowData] = useState(null);
  // new data for dynamic
  // const [gridData, setGridData] = useState([]);

  useEffect(() => {
    if (updateGridData) {
      // setGridData(updateGridData.active);
      const now = new Date();
      const startOfPreviousMonth = getStartOfPreviousMonth(now);
      const endOfNextMonth = getEndOfNextMonth(now);
      fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
      fetchData(activeTab);
      if (selectedRowData) {
        loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id);
      }
    }
    else {
      console.log('No Data');
    }
  }, [updateGridData]);

  // console.log("NNN", gridData);
  let checkUlds = [];
  let filterForCheck = false;

  useEffect(() => {
    if (gridRefs[activeTab]?.current) {

      const source = {
        datatype: 'json',
        datafields: [
          // { name: 'selected', type: 'bool' },
          { name: 'bookingtruck_no', type: 'string' },
          { name: 'bookingtruck_id', type: 'string' },
          { name: 'bookingtruck_date_id', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'RStatus', type: 'string' },
          { name: 'departure_date', type: 'string' },
          { name: 'departure_time', type: 'string' },
          { name: 'board_point', type: 'string' },
          { name: 'off_point', type: 'string' },
          { name: 'arrival_date', type: 'string' },
          { name: 'travel_time', type: 'string' },
          { name: 'arrival_time', type: 'string' },
        ],
        localdata: gridData[activeTab],
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },
        { text: 'Bookingtruck No.', filtertype: 'textbox', datafield: 'bookingtruck_no', width: '14%', cellclassname: 'firstcl', },
        // { text: 'Status', filtertype: 'textbox', datafield: 'Status', width: '17%', },
        {
          text: 'Status',
          filtertype: 'checkedlist',
          filteritems: [
            { label: 'Scheduled', value: 's' },
            { label: 'To be Planned', value: 't' },
            { label: 'Planning in Progress', value: 'p' },
            { label: 'Planning Finalized', value: 'f' },

          ],
          datafield: 'status',
          width: '17%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            // Check the value of the 'Status' field
            // console.log('12', rowdata);

            if (rowdata.status === 'Scheduled') {
              // Return HTML with class 'inactive' for 'i' status
              return '<div class="jqx-grid-cell-left-align bookingstatus scheduled"> Scheduled </div>';
            } else if (rowdata.status === 'To be Planned') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus tbplanned">To be Planned</div>';
            }
            else if (rowdata.status === 'Planning in Progress') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pprogress">Planning in Progress</div>';
            }
            else if (rowdata.status === 'Planning Finalized') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pfinalized">Planning Finalized</div>';
            }
            else {
              // Return default HTML
              return defaulthtml;
            }
          }
        },
        { text: 'Departure Date', filtertype: 'textbox', datafield: 'departure_date', width: '14%' },
        { text: 'Departure Time', filtertype: 'textbox', datafield: 'departure_time', width: '14%' },
        // { text: 'Arrival Date', filtertype: 'textbox', datafield: 'arrival_date', width: '12%' },
        { text: 'Arrival Time', filtertype: 'textbox', datafield: 'arrival_time', width: '12%' },
        { text: 'Boardpoint', filtertype: 'textbox', datafield: 'board_point', width: '12%' },
        { text: 'Offpoint', filtertype: 'textbox', datafield: 'off_point', width: '12%' },
      ];

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
      };


      window.$(gridRefs[activeTab]?.current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab]?.current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab]?.current).off('rowclick');
      window.$(gridRefs[activeTab]?.current).on('rowclick', async (event) => {
        // console.log('event', event.args.row.bounddata);
        const args = event.args.row.bounddata;

        console.log('args', args);
        // const rowData = dataAdapter.records[args.index];
        // console.log('rowdata', rowData);
        loadDetails(args.bookingtruck_id, args.bookingtruck_date_id);


        // window.$(gridRefs[activeTab]?.current).jqxGrid('autoresizecolumns');
      });

    }

  }, [gridData]);

  // row selection by checkbox
  window.$(gridRefs[activeTab]?.current).on('rowselect', (event) => {
    if (event.args.row) {
      const selectedRow = event.args.row;
      const uldNumber = selectedRow.bookingtruck_id;
      const selectedRowId = selectedRow.uid;
      if (!checkUlds.includes(uldNumber)) {
        checkUlds.push(uldNumber);
      }
      // console.log(checkUlds);
      // if (!gridSelect.some(row => row.bookingtruck_id === uldNumber)) {
      //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
      // }
      setGridSelect(prevGridSelect => {
        if (!prevGridSelect.some(row => row.bookingtruck_id === uldNumber)) {
          return [...prevGridSelect, selectedRow];
        }
        return prevGridSelect;
      });
    } else {
      if (event.args.rowindex.length > 0) {
        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        setGridSelect(allIds);
      } else {
        setGridSelect([]);
      }
    }
    // console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)
    // const bookTruckid = event.args.row.bookingtruck_id;
    // const selectedRow = event.args.row;
    // if (event.args.row) {

    //   setGridSelect(prevGridSelect => {
    //     if (!prevGridSelect.some(row => row.bookingtruck_id === bookTruckid)) {
    //       return [...prevGridSelect, selectedRow];
    //     }
    //     return prevGridSelect;
    //   });
    //   // setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
    // } else {
    //   if (event.args.rowindex.length > 0) {
    //     const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
    //     setGridSelect(allIds);
    //   } else {
    //     setGridSelect([]);
    //   }
    // }
  });

  window.$(gridRefs[activeTab]?.current).on('rowunselect', (event) => {
    if (event.args.row) {
      const unselectedRowId = event.args.row.bookingtruck_id;
      setGridSelect(prevSelection => prevSelection.filter(row => row.bookingtruck_id !== unselectedRowId));
      // if(filterForCheck!=true){

      // if (!checkUlds.includes(unselectedRowId)) {
      //   checkUlds.push(unselectedRowId);
      // } else {
      //   checkUlds = checkUlds.filter(item => item !== unselectedRowId);
      // }

      //   const unselectedRowId = event.args.row.bookingtruck_id;
      //   setGridSelect(prevSelection => prevSelection.filter(id => id.bookingtruck_id !== unselectedRowId));
      // } else {
      //   setGridSelect([]);
      // }
    }
  });
  // End row selection 

  const [dataToSend, setDataToSend] = useState({});
  const loadDetails = async (number, dateid) => {
    try {
      const res = await withRFSToken.post(BOOKINGTRUCKDETAILS, { bookingtruck_id: number, bookingtruck_date_id: dateid, })
        .then(function (res) {
          const innerData = res.data.response_data;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          if (res.data.response_code == 200) {
            setSelectedRowData(res.data.response_data);
            setDataToSend({bookingtruck_id: innerData?.bookingtruck_id, bookingtruck_date_id: innerData?.bookingtruck_date_id, date: innerData?.date})
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  }

  useImperativeHandle(ref, () => ({
    handleCloseClick,
  }));

  const handleCloseClick = () => {
    setSelectedRowData(null);
  };
  const handleDeleteButtonClick = () => {
    deleteSelectedRows(gridSelect);
    // if (gridSelect){
    //   handleShowConfirmation(deleteSelectedRows);
    // }
  };
  const deleteSelectedRows = async (selectedIds) => {
    // Perform deletion logic here using the selected IDs
    // console.log("Archive selected IDs:", selectedIds);
    const ids = selectedIds.map(id => id.bookingtruck_date_id)
    // console.log("🚀 ~ deleteSelectedRows ~ ids:", ids)
    const uniqueIds = Array.from(new Set(ids));
    // Now you can send the selected IDs to your API or perform any other action
    if (selectedIds.length > 0) {
      try {
        const response = await withRFSToken.post(BOOKINGTRUCKMOVE, { bookingtruck_nos: uniqueIds, action: activeTab === 'Active' ? 'D' : 'A' });
        if (response.data.response_code === 200) {
          fetchData(activeTab);

          const now = new Date();
          const startOfPreviousMonth = getStartOfPreviousMonth(now);
          const endOfNextMonth = getEndOfNextMonth(now);
          fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
        }
        // reloadGrid();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    window.$(gridRefs[activeTab]?.current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab]?.current).jqxGrid('clearselection');
    // dispatch(fetchStationGridData());
    // reloadGrid();
  };
  // const reloadGrid = async () => {
  //   try {
  //       const res = await axios.post(process.env.REACT_APP_BASE_URL + DASHBOARD, {}, {
  //           headers: {
  //               'Authorization': `Bearer ${localStorage.getItem('token')}`,
  //               'Content-Type': 'application/json'
  //           }
  //       });
  //       const innerData = res.data.data;
  //       setPlanData(innerData);
  //   } catch (error) {
  //       console.error('Error reloading data:', error);
  //   }
  // };

  const showDownloadModal = () => {
    setDownloadOpen(true);
  };
  const closeDownloadModal = () => {
    setDownloadOpen(false);
  };

  const exportToExcel = () => {
    if (gridRefs[activeTab]?.current) {
      window.$(gridRefs[activeTab]?.current).jqxGrid('exportdata', 'xls', 'GridData');
    }
  };
  const exportToPDF = () => {
    if (gridRefs[activeTab]?.current) {
      window.$(gridRefs[activeTab]?.current).jqxGrid('exportdata', 'pdf', 'GridData');
    }
  };

  const handleEditClick = () => {
    // Extract the 10 fields you need from selectedRowData
    const dataToSend = {
      booking_type: 'E',
      bookingtruck_no: selectedRowData.bookingtruck_no,
      boardpoint: selectedRowData.boardpoint,
      boardpoint_address: selectedRowData.boardpoint_address,
      offpoint: selectedRowData.offpoint,
      offpoint_address: selectedRowData.offpoint_address,
      trip_type: selectedRowData.trip_type,
      date: selectedRowData.data,
      time: selectedRowData.trip_type,
      selected_days: selectedRowData.selected_days,
      freq_date: selectedRowData.freq_date,
      freq_time: selectedRowData.freq_time,
      start_date: selectedRowData.start_date,
      end_date: selectedRowData.end_date,
      departure_date: selectedRowData.departure_date,
      departure_time: selectedRowData.departure_time,
      arrival_time: selectedRowData.arrival_time
    };
    console.log("🚀 ~ handleEditClick ~ dataToSend:", dataToSend)

    // Call the parent's edit function
    const datas = { ...selectedRowData, add_edit: 'E' };
    onEdit(datas);
  };
  // ++++++++++++++ Calender 
  const handleDayClick = async (date, event) => {
    // console.log('date');
    // console.log("🚀 ~ handleDayClick ~ date:", date)

    // const calendar = document.querySelector('.scrollable-calendar');
    // const days = calendar.querySelectorAll('.day');
    // days.forEach(day => {
    //   day.classList.remove('active');
    // });
    // event.currentTarget.classList.add('active');

    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2); // Ensure month is 2 digits
    const day = (`0${date.getDate()}`).slice(-2); // Ensure day is 2 digits

    const formattedDate = `${year}-${month}-${day}`;
    setDateData(formattedDate);

    try {
      const res = await withRFSToken.post(BOOKINGTRUCKGRID, { tab_name: (activeTab == 'Active' ? 'IA' : (activeTab == 'Trash' ? 'IT' : '')), date: formattedDate })
        .then(function (res) {
          const innerData = res.data.Rows;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          setGridData({ Active: innerData, Trash: innerData });

          const innerDataCal = res.data.chart_data;
          const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
          const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
          // Chart
          // setStatusOptions(prevOptions => ({
          //   ...prevOptions,
          //   xaxis: {
          //     ...prevOptions.xaxis,
          //     categories: statusLabel
          //   }
          // }));
          const colors = [
            "rgba(255, 181, 95, 1)",
            "rgba(203, 140, 255, 1)",
            "rgba(99, 169, 255, 1)",
            'rgba(84, 202, 82, 1)',
            'rgba(255, 107, 107, 1)',
          ];

          const condsData = statusData.map((value, index) => ({
            x: statusLabel[index],
            y: value,
            // fillColor: colors[index % colors.length]
          }));
          setStatusSeries([{
            name: "Bookingtruck",
            data: condsData
          }]);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
    // setSelectedDate(date);  // Store the selected date
    // if (childRef.current) {
    //   childRef.current.handleCloseClick();
    // }
  };
  const [borderDates, setBorderDates] = useState([]);
  // const borderDates = [
  //   { date: new Date(2024, 8, 15), colors: ['#D6D6D6'] },
  //   { date: new Date(2024, 8, 20), colors: ['#FF5522'] },
  //   { date: new Date(2024, 8, 25), colors: ['#FFB63F'] },
  //   { date: new Date(2024, 8, 22), colors: ['#20A749'] },
  // ];



  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lastDayOfMonth, setLastDayOfMonth] = useState(null);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    return `${year}-${month}-${day}`;
  };

  const getStartOfPreviousMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  };

  const getEndOfNextMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 2, 0); // 0th day gives last day of the next month
  };

  const getLastDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0); // 0th day of the next month gives last day of the current month
  };

  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const startOfPreviousMonth = getStartOfPreviousMonth(activeStartDate);
    const endOfNextMonth = getEndOfNextMonth(activeStartDate);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));
  };

  const handleMonthClick = (date) => {
    const lastDay = getLastDayOfMonth(date);
    setLastDayOfMonth(formatDate(lastDay));
    console.log("Last day of the clicked month:", formatDate(lastDay));

    const startOfPreviousMonth = getStartOfPreviousMonth(date);
    const endOfNextMonth = getEndOfNextMonth(date);
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
  };

  const statusToColorMap = {
    s: '#D6D6D6',
    t: '#FF5522',
    p: '#FFB63F',
    f: '#20A749'
  };


  useEffect(() => {
    const now = new Date();
    const startOfPreviousMonth = getStartOfPreviousMonth(now);
    const endOfNextMonth = getEndOfNextMonth(now);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));

    // isMounted.current = false;
    if (isMountedCal.current) return;
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
    isMountedCal.current = true;
  }, []);

  const fetchCallanderData = async (sd, ed) => {
    try {
      // const dateP = dateData ? `date: ${dateData}` : ''
      const res = await withRFSToken.post(CALENDER, { tab_name: (activeTab == 'Active' ? 'IA' : (activeTab == 'Trash' ? 'IT' : '')), start_date: sd, end_date: ed })
        .then(function (res) {
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:", innerData)
          const transformedDates = innerData.map(item => ({
            date: new Date(item.booking_date), // Convert booking_date to Date object
            colors: [statusToColorMap[item.planning_status]] // Get the corresponding color
          }));

          setBorderDates(transformedDates);

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const dateEntry = borderDates.find(d => d.date.toDateString() === date.toDateString());
      const colors = dateEntry?.colors || [];

      return (
        <div className="multi-border" style={{ height: '100%' }}>
          {colors.map((color, index) => (
            <div
              key={index}
              className="border-stripe"
              style={{ borderBottom: `3px solid ${color}` }}

            />
          ))}
        </div>
      );
    }
    return null;
  };

  const getDeialsClick = (e) => {
    localStorage.removeItem('BTDetails');
    // const storageData = { selectedRowData };
    localStorage.setItem('BTDetails', JSON.stringify(selectedRowData));
    if (e == 'P') {
      window.location.href = '/BookingtruckDetails/Planning'
    } else {
      window.location.href = '/BookingtruckDetails'
    }
  }
  const handleOrderTruck = () => {
    localStorage.removeItem('OT');
    const sendData = {
      truck_type: 'B',
      bookingTruck_type: 'E',
      existing_date: selectedRowData.date
    }
    localStorage.setItem('OT', JSON.stringify(sendData));
    window.location.href = '/OrderTruck'
  }

  const getToDeialsClick = (id,e) => {
    localStorage.removeItem('TODetails');
    const storageData = { truck_orders_id: id, tab: e };
    localStorage.setItem('TODetails', JSON.stringify(storageData));
    window.location.href = '/TruckOrderDetails'
  }


  return (
    <>
      {console.log('sadd', gridSelect)}
      {downloadOpen && <DownloadGrid download_area='bt' download_sec={activeTab == 'Active' ? 'IA' : 'IT'} onClose={closeDownloadModal} />}
      <div className='exp-btn'>
        <button onClick={handleDeleteButtonClick}> <img src={activeTab === 'Active' ? Trash : Activ} alt="icon" /> Move to {activeTab === 'Active' ? 'Trash' : 'Active'}</button>
        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
      </div>
      <div className="maindiv">
        <div className='trashdonload rfs_grid'>
          <Tabs defaultActiveKey={activeTab} id="nested" className="booking_tab" onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''}>
            <Tab eventKey="Active" title={<span>Active</span>}>
              <div ref={gridRefs.Active} className='bookinggrid'></div>
            </Tab>
            <Tab eventKey="Trash" title={<span>Trash</span>}>
              <div ref={gridRefs.Trash} className='bookinggrid'></div>
            </Tab>
          </Tabs>
        </div>
        <div className='rfsRight mt-45'>
          {!selectedRowData && (
            <>
              <div className='calender_rfs mb-3 p-0'>
                <div>
                  <Calendar
                    tileClassName={({ date, view }) =>
                      view === 'month' && date.toDateString() === new Date().toDateString() ? 'selected-tile' : ''
                    }
                    tileContent={tileContent}
                    onClickDay={(date, event) => handleDayClick(date, event)}
                    // onClick={(event) => handleDayClick(date, event)}
                    // onActiveStartDateChange={handleActiveStartDateChange}

                    // onClickMonth={handleMonthClick}
                    onActiveStartDateChange={({ activeStartDate, view }) => {
                      // handleActiveStartDateChange();
                      if (view === 'month') {
                        handleMonthClick(activeStartDate);
                      }
                    }}
                  />
                </div>
              </div>

              <div className='calender_rfs'>
                <div className="new_chart">
                  <h3>Status Overview</h3>
                  <p>Overview of Current Booking Truck Statuses</p>
                </div>
                <ApexCharts
                  options={statusOptions}
                  series={statusSeries}
                  type="bar"
                  height={'88%'}
                />
              </div>
            </>

          )}
          {/* Display the selected row data */}
          {selectedRowData && (
            <div className='SecondDiv rfs_width'>
              {console.log('555', selectedRowData)}
              <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
              <div className='girddtals_header'>
                <h3>
                  {selectedRowData.bookingtruck_no}
                  <span className={
                    selectedRowData.status === 'Scheduled' ? 'bookingstatus scheduled mx-2 abslt'
                      : (selectedRowData.status === 'To be Planned' ? 'bookingstatus tbplanned mx-2 abslt'
                        : (selectedRowData.status === 'Planning in Progress') ? 'bookingstatus pprogress mx-2 abslt'
                          : ((selectedRowData.status === 'Planning Finalized' ? 'bookingstatus pfinalized mx-2 abslt'
                            : 'bookingstatus')))
                  }>
                    {selectedRowData.status}
                  </span>
                </h3>
                <div className='d-flex actbtn justify-content-between'>
                  <div className='d-flex'>
                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                    <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <FontAwesomeIcon icon={faBolt} /> Action
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handleEditClick}>Edit Bookingtruck</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={() => getDeialsClick('P')}>Planning</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={handleOrderTruck}>Order Truck</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className='viwall'>
                    <Link to='#' onClick={() => getDeialsClick('D')}>View Details</Link>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between rabord'>
                <div className='firstbrd'>
                  <p>Boardpoint</p>
                  <span>{selectedRowData?.boardpoint}</span>
                </div>
                <div className='middlebrd'>
                  <p>{selectedRowData?.departure_date}</p>
                  <p><img src={Cargotruck} /></p>
                  <p>{selectedRowData?.departure_time} - {selectedRowData?.arrival_time}</p>
                </div>
                <div className='lastbrd'>
                  <p>Offpoint</p>
                  <span>{selectedRowData?.offpoint}</span>
                </div>
              </div>
              <div>
                <h3>Operational Trucks</h3>
                {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                  <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                    {/* {console.log("🚀 ~ ExportActive ~ truck:", truck)} */}
                    <div>
                      <span>Truck No</span>
                      <h4>{truck.truck_no}</h4>
                    </div>
                    {/* <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                      <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                    </div> */}
                    <div className={truck.status == 'Offer Received' ? 'offer_reecv' : (truck.status == 'Booked' ? 'booked' : 'offer_rqst')}>
                      <span>{truck.status}</span>
                    </div>
                    <div>
                      <Link to='#' onClick={() => getToDeialsClick(truck.truck_orders_id, 'shipment')}>Details</Link>
                    </div>
                  </div>
                ))}
              </div>
              <ImageUpload
                attachable_type={selectedRowData?.trip_type == 'F' ? 'booking_schedule' : 'booking_schedule_date'}
                attachable_id={selectedRowData?.trip_type == 'F' ? dataToSend : selectedRowData.bookingtruck_date_id}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id)}
                attachment_no={selectedRowData.bookingtruck_no}
              />
              <div>
                <ActivityComments
                  commentable_type={"booking_schedule_date"}
                  commentable_id={selectedRowData.bookingtruck_date_id}
                  allactivities={selectedRowData.activities}
                  onReloadDetails={() => loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
});
export default ImportGrid;
// export {JGrid as default, exportToPDF}